import { APPROVAL_DOA_VIEW } from '@/fixtures'

export default {
  path: 'approval-online-doa',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Approval Online DOA',
      component: () => import('@/views/menus/ApprovalOnlineDoa/Index'),
      meta: {
        permission: APPROVAL_DOA_VIEW
      }
    }
  ]
}
